<template>
    <div class="mobile_screen">
        <div v-if="!isEmpty(arrBigCat5FollowRead)" class="big_cat_screen">
            <img :src="geneNetworkPicture(arrBigCat5FollowRead[0].background.backgroundPicture)" class="big_cat_blur_backgroud"/>
            <div id="navigation_title" class="navigation" :style="{height:getNavCount()+'px', 'margin-top': isWeixinBrowser() ? '15px' : '0px'}">
                <div :style="{height:getStateHeight()+'px'}"></div>
                <div class="left" @click="goBack"><i class="icon-thin_back"/></div>
                <div class="title">故事音频</div>
                <div class="right_post" :style="{'margin-top': getStateHeight()/2 + 'px'}" @click="nextClick">继续 ></div>
                <div class="clear"></div>
            </div>
            <div :style="{'padding-top':(getNavCount() + 20) +'px'}"></div>
            <div class="follow_content">
                <div class="follow_content_item" v-for="(item,index) in arrBigCat5FollowRead" :key="index">
                    <div class="follow_cell">
                        <div class="img">
                            <img class="img_show" v-lazy="getWholeThumbnailCut(item.picture, 190, 190)">
                        </div>
                        <div class="content">
                            <div class="title">{{item.page}}</div>
                            <div class="english_interpretation"
                                 v-if="!isEmpty(item.chineseInterpretation)"
                                 @click="popupClick(index)">
                                <img src="@/assets/icon_english_english.png" height="15" width="15"/>
                                <span class="english">中英解释</span>
                            </div>
                        </div>
                        <div class="play_action" @click="playAction(index)">
                            <img :src="geImage(index)"/>
                        </div>
                        <div class="clear"></div>
                    </div>
                </div>
            </div>
            <div style="height:50px"></div>
            <audio v-bind:src="audioUrl" id="musicMp3" @ended="playEnded" @error="playError" autoplay="autoplay"
                   controls=""/>
            <mt-popup
                    v-model="popupVisible"
                    popup-transition="popup-fade"
                    class="popup_style">
                <div v-if="!isEmpty(interpretationContent)" @click="closePopup">
                    <pre>{{interpretationContent}}</pre>
                </div>
            </mt-popup>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                lessonId: 0,
                arrBigCat5FollowRead:[],
                audioUrl: "",
                isPlaying: true,
                playIndex: 0,
                popupVisible: false,
                isContinuity: 1,
                interpretationContent: ""
            }
        },
        methods: {
            goToBack() {
                this.goBack(this.$router);
            },
            nextClick() {

            },
            popupClick(index) {
                if (index < 0 || index >= this.arrBigCat5FollowRead.length) {
                    return;
                }

                let vBigCat5FollowRead = this.arrBigCat5FollowRead[index];

                if (!this.isEmpty(vBigCat5FollowRead.chineseInterpretation)) {
                    this.interpretationContent = vBigCat5FollowRead.chineseInterpretation;
                    this.popupVisible = true;
                    return;
                }
            },
            closePopup:function() {
                this.popupVisible = false;
            },
            geImage:function(index){
                let that = this;
                return require('@/assets/' + (that.isPlaying && this.playIndex === index  ? 'player_pause1' : 'player_play1') + '.png');
            },
            getStateHeight: function () {
                return this.getCount(this.$store.state.statusheight);
            },
            getNavCount: function () {
                return this.getStateHeight() + 44;
            },
            playAction(index) {
                this.playIndex = index;
                this.playAudio();
            },
            playAudio() {
                let that = this;
                let musicMp3 = document.getElementById('musicMp3');

                if (that.isPlaying) {
                    musicMp3.pause();
                    that.isPlaying = false;
                    this.isContinuity = 0;
                    this.playIndex = 0;
                    return;
                }

                if (that.playIndex < 0 || that.playIndex >= that.arrBigCat5FollowRead.length) {
                    return;
                }

                that.audioUrl = that.$qiNiuDomainBase + that.arrBigCat5FollowRead[that.playIndex].audio;
                that.isPlaying = true;
                let playPromise = musicMp3.play();

                if (playPromise !== undefined) {
                    playPromise.then(() => {
                    }).catch((e) => {
                        let vError = JSON.stringify(e);

                        if (!that.isEmpty(vError) && vError != "{}") {
                            that.isPlaying = false;
                            window.console.log("播放失败:playAudio:" + JSON.stringify(e));
                        }
                    });
                } else {
                    that.isPlaying = false;
                    window.console.log("播放失败:playAudio");
                }
            },
            playStart() {
                this.isPlaying = true;
            },
            playError() {
                window.console.log("playError：" + this.isContinuity)
                var musicMp3 = document.getElementById('musicMp3');
                musicMp3.pause();
                this.isPlaying = false;
            },
            playEnded() {
                window.console.log("playEnded：" + this.isContinuity)
                var musicMp3 = document.getElementById('musicMp3');
                musicMp3.pause();
                this.isPlaying = false;

                if (this.isContinuity === 0) {
                    return;
                }

                this.playIndex++;

                if (this.playIndex < this.arrBigCat5FollowRead.length) {
                    this.playAudio(this.arrBigCat5FollowRead[this.playIndex].audio);
                } else {
                    this.playIndex = 0;
                    this.isContinuity = 0;
                }
            }
        },
        beforeCreate() {
            let vlessonId = parseInt(this.$route.query.lessonId);
            let url = "bigCat/getLessonFollowRead/" + vlessonId;
            let that = this;

            this.$axios.get(url).then((response) => {
                window.console.log(JSON.stringify(response.data));
                that.arrBigCat5FollowRead = response.data;
                that.lessonId = vlessonId;

                if (!that.isEmpty(that.arrBigCat5FollowRead)) {
                    that.audioUrl = that.$qiNiuDomainBase + that.arrBigCat5FollowRead[0].audio;
                }

                that.$nextTick(() => {
                    $(window).scroll(function () {
                        var scrollTop = parseFloat(parseFloat($(window).scrollTop()));

                        if (scrollTop > 44) {
                            $("#navigation_title").removeClass("navigation");
                            $("#navigation_title").addClass("navigation_white");
                        } else {
                            $("#navigation_title").removeClass("navigation_white");
                            $("#navigation_title").addClass("navigation");
                        }
                    });
                });
            }).catch(function (error) {
                window.console.log(error)
            });
        }
    }
</script>

<style scoped>

    .navigation .right_post, .navigation_white .right_post {
        width: 80px;
        height: 30px;
        float: right;
        position: absolute;
        right: 15px;
        top: 50%;
        -webkit-transform: translateY(-50%);
        border-radius: 13px;
        -webkit-border-radius: 13px;
        -moz-border-radius: 13px;
        background-color: #FFAA00;
        font-size: 16px;
        font-weight: bold;
        color: white;
        text-align: center;
        line-height: 30px;
    }
    .follow_content {
        margin-bottom: 50px;
    }
    .follow_content .follow_content_item {
        border: 3px solid #fdb42b;
        margin: 20px;
        border-radius: 10px;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
    }
    .follow_content .follow_content_item .follow_cell {
        margin:10px;
    }
    .follow_content .follow_content_item .follow_cell .img {
        float: left;
    }
    .follow_content .follow_content_item .follow_cell .img img {
        float: left;
        width: 80px;
        height: 80px;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
    }
    .follow_content .follow_content_item .follow_cell .content {
        float: left;
        margin-left: 10px;
        width: calc(100% - 80px - 10px - 10px - 50px);
    }
    .follow_content .follow_content_item .follow_cell .content .title {
        color: #fdb42b;
        font-size: 18px;
        font-weight: bold;
    }
    .follow_content .follow_content_item .follow_cell .content .des {
        margin-top: 5px;
        color: #666666;
        font-size: 15px;
        display:-webkit-box;
        -webkit-line-clamp:2;
        -webkit-box-orient:vertical;
        overflow:hidden;
        text-overflow:ellipsis;
    }
    .follow_content .follow_content_item .follow_play_cell {
        position:relative;
        width: 100%;
        padding-bottom:100%;
    }
    .english_interpretation {
        margin-top: 30px;
        display: inline-block;
    }
    .english_interpretation img {
        float: left;
        margin-top: 4px;
        margin-right: 5px;
    }
    .english_interpretation .english {
        color: white;
        font-size: 14px;
    }
    .play_action {
        float: right;
        margin-top: 15px;
    }
    .play_action img {
        width: 50px;
        height: 50px;
    }
    audio {
        display: none;
    }
    .popup_style {
        width: calc(100% - 60px);
        padding-left: 15px;
        padding-right: 15px;
        padding-top: 20px;
        padding-bottom: 20px;
        margin-right: 30px;
        border-radius: 10px;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
    }
    .popup_style pre {
        text-align: left;
        font-size: 20px;
        font-weight: bold;
        white-space: pre-wrap; /* css-3 */
        white-space: -moz-pre-wrap; /* Mozilla, since 1999 */
        white-space: -o-pre-wrap; /* Opera 7 */
        word-wrap: break-word; /* Internet Explorer 5.5+ */
    }
</style>